import { useMemo, useCallback, forwardRef } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { MenuItem } from "@mui/material"
import { some } from "lodash"
import { useNavigate } from "react-router-dom"

const SettingsMenuItem = forwardRef(({ label, Icon, to, className, closeMenu, activeUrls }, ref) => {
  const navigate = useNavigate()
  const { pathname } = window.location

  const goTo = useCallback(() => {
    if (to[0] === "/") {
      window.location = to
    } else {
      const [, basePath] = pathname.split("/")
      navigate(`/${basePath}/${to}`)
    }

    closeMenu()
  }, [pathname, closeMenu, to, navigate])

  const active = useMemo(() => {
    if (activeUrls) {
      return some(activeUrls, url => pathname.indexOf(url) > -1)
    }

    return pathname.indexOf(to) > -1
  }, [pathname, to, activeUrls])

  return <MenuItem ref={ref} className={classNames("settings-menu-item", { active }, className)} onClick={goTo}>
    <Icon />
    <span className="label">{label}</span>
  </MenuItem>
})

SettingsMenuItem.displayName = "SettingsMenuItem"

SettingsMenuItem.propTypes = {
  to: PropTypes.string.isRequired,
  closeMenu: PropTypes.func.isRequired,
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  Icon: PropTypes.elementType.isRequired,
  activeUrls: PropTypes.arrayOf(PropTypes.string),
}

export default SettingsMenuItem
